import { Injectable } from '@angular/core';
import { Address, B2BUser, TranslationService } from '@spartacus/core';
import { BehaviorSubject, Observable, take } from 'rxjs';
import {
  AddressRequest,
  CarriersRequest,
  ShippingPreferencesRequest,
  SubDeliveryMethodsRequest,
} from './checkout.model';
import { CheckoutAuxAdapter } from './checkout-aux.adapter';
import { StatusRequest } from '../../../../../core/models/request-status.model';
import { ShippingPriorityUnformatted } from '../../../../../core/models/cart.model';
import { User } from '@spartacus/user/account/root';
import { B2BUserRole } from '../../../../../core/enums/b2bUserRoles';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../components/toaster/toaster.model';

@Injectable({
  providedIn: 'root',
})
export class CheckoutAuxService {
  customerPurchaseOrderNumber$ = new BehaviorSubject<string>('');
  formShippingPriorityIsOK$ = new BehaviorSubject<boolean>(false);

  constructor(
    private checkoutAux: CheckoutAuxAdapter,
    private translationService: TranslationService,
    private toasterService: ToasterService,
  ) {}

  createAddress(address: Address): Observable<AddressRequest> {
    return this.checkoutAux.createAddress(address);
  }

  getShippingPreferences(): Observable<ShippingPreferencesRequest> {
    return this.checkoutAux.getShippingPreferences();
  }

  setShippingPreference(newPreference: string): Observable<StatusRequest> {
    return this.checkoutAux.setShippingPreferences(newPreference);
  }

  getCarriers(): Observable<CarriersRequest> {
    return this.checkoutAux.getCarriers();
  }

  getSubDeliveryMethods(): Observable<SubDeliveryMethodsRequest> {
    return this.checkoutAux.getSubDeliveryMethods();
  }

  setShippingPriority(form: ShippingPriorityUnformatted): Observable<StatusRequest> {
    return this.checkoutAux.setShippingPriority(form);
  }

  userIsAbleToCheckout(user: User): boolean {
    const roles = (<B2BUser>user).roles;

    return roles?.includes(B2BUserRole.ADMIN) ||
      roles?.includes(B2BUserRole.SALESREP) ||
      roles?.includes(B2BUserRole.BUYER)
      ? true
      : false;
  }

  handlerUserNotAbleToCheckout(): void {
    this.translationService
      .translate('checkoutB2B.invalid.accountType')
      .pipe(take(1))
      .subscribe(translation => {
        this.toasterService.init({
          type: TOASTER_TYPE.WARNING,
          content: translation,
        });
      });
  }
}
